import script from "./CharaIntroduction.vue?vue&type=script&setup=true&lang=js"
export * from "./CharaIntroduction.vue?vue&type=script&setup=true&lang=js"

import "./CharaIntroduction.vue?vue&type=style&index=0&id=7a8c1177&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a8c1177"]])

export default __exports__